/**
 * @license Givaudan
 * @author Ayoub MHAMDI
 */

import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    RouterModule,
    MatTooltipModule,
  ],
  standalone: true,
})
export class ContentHeaderComponent {
  @Input() title: string = '';
  @Input() titleContact: string = '';
  @Input() subtitle: string = '';
  @Input() subtitleBasket: string = '';
  @Input() subtitleContact: string = '';
  @Input() subtitleBold: string = '';
  @Input() align: 'left' | 'center' | 'right' | null = null;
  @Input() maxWidth: 'large' | 'extra-large' | null = null;
  @Input() backLink: string | null = '';
  @Input() backLinkText: string = '';
  @Input() tooltip: string = '';
}
